import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Rss } from "lucide-react";
import { fetchSiteSettings } from "@/services/news";
import { SocialNetworkIcon } from "@/lib/socialIcons";

export function Footer() {
  const { data: site } = useQuery({
    queryKey: ["site"],
    queryFn: fetchSiteSettings,
  });

  const year = new Date().getFullYear();
  const socialLinks =
    site?.social_links?.length
      ? site.social_links
      : [
          ...(site?.facebook_url
            ? [{ id: -1, label: "Facebook", url: site.facebook_url, icon: "facebook", order: 0 }]
            : []),
          ...(site?.instagram_url
            ? [{ id: -2, label: "Instagram", url: site.instagram_url, icon: "instagram", order: 1 }]
            : []),
        ];

  return (
    <footer className="mt-16 bg-brand-chrome text-white/85">
      <div className="portal-container grid gap-8 py-12 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-display text-xl font-bold text-white">{site?.site_name || "Eusebio News"}</p>
          <p className="mt-3 text-sm leading-relaxed text-white/80">
            {site?.tagline || "O maior e melhor portal de noticias de toda região"}
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            {socialLinks.map((link) => (
              <a
                key={link.id}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                className="rounded bg-white/15 p-2 hover:bg-white/25"
                aria-label={link.label}
              >
                <SocialNetworkIcon icon={link.icon} />
              </a>
            ))}
            <a href="/feed" className="rounded bg-white/15 p-2 hover:bg-white/25" aria-label="RSS">
              <Rss className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-white/65">Editorial</p>
          <ul className="mt-3 space-y-2 text-sm text-white/85">
            <li>
              <Link to="/" className="hover:text-white">
                Ultimas noticias
              </Link>
            </li>
            <li>
              <Link to="/busca" className="hover:text-white">
                Busca
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-white/65">Institucional</p>
          <ul className="mt-3 space-y-2 text-sm text-white/85">
            <li>
              <Link to="/contato" className="hover:text-white">
                Contato
              </Link>
            </li>
            <li>
              <Link to="/anuncie" className="hover:text-white">
                Anuncie / Parcerias
              </Link>
            </li>
            <li>
              <Link to="/privacidade" className="hover:text-white">
                Privacidade (LGPD)
              </Link>
            </li>
            <li>
              <Link to="/termos" className="hover:text-white">
                Termos de uso
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-white/65">Fale conosco</p>
          <ul className="mt-3 space-y-2 text-sm text-white/85">
            {site?.contact_email ? <li>{site.contact_email}</li> : null}
            {site?.contact_phone ? <li>{site.contact_phone}</li> : null}
            <li>
              <button
                type="button"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                className="hover:text-white"
              >
                Voltar ao topo
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15 px-4 py-4 text-center text-xs text-white/65">
        {year} {site?.site_name || "Eusebio News"}. Todos os direitos reservados.
      </div>
    </footer>
  );
}
